import React, { useEffect, useState } from 'react'
import { categoryAssemble, handleFilter, sortPackages } from '../utils/filter'
import { useModifySearch } from './useModifySearch';

const useFilterPackage = (packageResult) => {
    const [filters, setFilters] = useState({
        starRatings: [],
        priceRange: [],
        typeFilter: null
    });
    const [filteredPackages, setFilteredPackages] = useState([])
    const [carousalCategory, setCarousalCategory] = useState([])
    const { selectedCountry } = useModifySearch();
    const [activeCategories, setActiveCategories] = useState([]);

    useEffect(() => {
        setFilteredPackages(packageResult)
        setCarousalCategory(categoryAssemble(packageResult))
    }, [packageResult])

    const handleSort = (sortType) => {
        setFilteredPackages(sortPackages(filteredPackages, sortType))
    }

    const handleFilterChange = (filterKey, values) => {
        if (filterKey === "resetall") {
            setFilters({
                starRatings: [],
                priceRange: [],
                typeFilter: null,
            });
            setFilteredPackages(packageResult);
        } else {
            setFilters((prevFilters) => ({
                ...prevFilters,
                [filterKey]: values,
            }));
        }
    };

    useEffect(() => {
        if (!selectedCountry && filters.starRatings.length === 0 &&
            filters.priceRange.length === 0 && filters.typeFilter === null) {
            setFilteredPackages(packageResult);
            return;
        }

        const filtered = selectedCountry
            ? packageResult.filter(pkg =>
                pkg.BasicInfo?.Country?.some(country => country.Name === selectedCountry))
            : packageResult;

        setFilteredPackages(handleFilter(filtered, filters));
    }, [selectedCountry]);


    useEffect(() => {
        const applyFilters = () => {
            setFilteredPackages(handleFilter(packageResult, filters)); // Update filtered packages
        };
        applyFilters();
    }, [filters, packageResult]);


    const handleCategoryFilter = (selectedCategory) => {
        if (!selectedCategory || !selectedCategory.name) return;


        let test = [];

        setActiveCategories((prevCategories) => {
            test?.push('test')
            // Check if the category is already selected
            const isSelected = prevCategories.includes(selectedCategory.name);

            let updatedCategories;
            if (isSelected) {
                // If already selected, remove it (toggle off)
                updatedCategories = prevCategories.filter(
                    (cat) => cat !== selectedCategory.name
                );
            } else {
                // Otherwise, add it (toggle on)
                updatedCategories = [...prevCategories, selectedCategory.name];
            }

            // Apply filtering based on updated categories
            if (updatedCategories.length === 0) {
                setFilteredPackages(handleFilter(packageResult, filters)); // Reset to all packages if no category selected
            } else {
                const filtered = packageResult.filter((pkg) =>
                    pkg.BasicInfo?.Category?.some((cat) =>
                        updatedCategories.includes(cat.Name)
                    )
                );
                setFilteredPackages(handleFilter(filtered, filters));
            }

            return updatedCategories;
        });
    };




    return { filteredPackages, carousalCategory, handleSort, handleFilterChange, filters, handleCategoryFilter }
}

export default useFilterPackage